// extracted by mini-css-extract-plugin
export var activeListItem = "mega-menu-expanded-module--activeListItem--40ceb";
export var adButton = "mega-menu-expanded-module--adButton--ff1a1";
export var adContainer = "mega-menu-expanded-module--adContainer--c11d4";
export var adDivider = "mega-menu-expanded-module--adDivider--a51e8";
export var adImage = "mega-menu-expanded-module--adImage--40c7a";
export var adTitle = "mega-menu-expanded-module--adTitle--fe046";
export var cardLink = "mega-menu-expanded-module--cardLink--f7e08";
export var cardTitle = "mega-menu-expanded-module--cardTitle--fb485";
export var extraLinks = "mega-menu-expanded-module--extraLinks--fb6bc";
export var popoverContent = "mega-menu-expanded-module--popoverContent--86cc5";
export var popoverPanel = "mega-menu-expanded-module--popoverPanel--183fd";
export var sidebar = "mega-menu-expanded-module--sidebar--0b4ed";
export var sidebarList = "mega-menu-expanded-module--sidebarList--08f1a";
export var sidebarListItem = "mega-menu-expanded-module--sidebarListItem--f5608";
export var sidebarNavList = "mega-menu-expanded-module--sidebarNavList--1cb98";
export var sidebarWrapper = "mega-menu-expanded-module--sidebarWrapper--58dbc";
export var tabCard = "mega-menu-expanded-module--tabCard--bf058";
export var tabCardExtraLinks = "mega-menu-expanded-module--tabCardExtraLinks--9bac1";
export var tabContent = "mega-menu-expanded-module--tabContent--0ad7a";